import React , {useEffect, useState} from 'react'
import Navbar from "../../Components/Navbar";
import { project2Mockup1 , project2Mockup2 , project2Mockup3} from '../../Assets';
import ProjectDetailsDb from "../../DB/ProjectDetails.json"
import ProjectHeaderDetails from '../../Components/ProjectHeaderDetails';

const Project3Details = () => {

    const [projectData , setProjectData] = useState([]);

    useEffect(() =>{
        window.scrollTo(0, 0);
        setTimeout(() =>{
            setProjectData(ProjectDetailsDb?.projectsDetails[2])
        },1000)
    },[])

    useEffect(() =>{
        console.log(projectData)
    },[projectData])

  return (
    <>
        <div className='project-details-app-main-wrapper'>
            <Navbar />
            <div className="projects-details-cover-wrapper">
                <div className="container">
                    <div className="project-details-content-cover">
                        <ProjectHeaderDetails data={projectData}/>

                        <div className='projects-det-cards-cover'>
                            <div className="row">
                                <div className="col-lg-4">
                                    <div className="proj-small-card-cover">
                                        <div className="proj-small-card">
                                            <img src={project2Mockup2}></img>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-4">
                                    <div className="proj-high-card-cover">
                                        <div className="proj-small-card">
                                            <img src={project2Mockup1}></img>
                                        </div>
                                    </div>
                                </div>
                                
                                <div className="col-lg-4">
                                    <div className="proj-small-card-cover">
                                        <div className="proj-small-card">
                                            <img src={project2Mockup3}></img>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>

                        <div className="projects-description-cover-box">
                            
                            <div className="projects-description-content-cover">
                                <div className="row">
                                    <div className="col-lg-8">
                                        <div className="projects-description-content-box">
                                            <div className="projects-title-header">
                                                <h2>Project Description</h2>
                                            </div>
                                            <div className="projects-description-content">
                                                <p>Habitant libero ultricies fusce lacus fermentum augue nulla euismod penatibus quis nam netus, posuere tortor condimentum pulvinar rutrum ad diam cubilia tempor sem. Lobortis cubilia diam suscipit massa suspendisse vitae, eu lectus neque ridiculus facilisis curae interdum, augue. Non ut porttitor nostra id accumsan habitant arcu, nullam venenatis facilisi primis penatibus consequat bibendum mollis, lacus ad erat pulvinar ligula etiam. Nullam ullamcorper et habitasse vestibulum nibh venenatis torquent.</p>
                                            <p>
                                            Non ut porttitor nostra id accumsan habitant arcu, nullam venenatis facilisi primis penatibus consequat bibendum mollis, lacus ad erat pulvinar ligula etiam. Nullam ullamcorper et habitasse vestibulum nibh venenatis torquent.
                                            </p>
                                    
                                            </div>
                                        </div>
                                    </div>
                                    <div className='col-lg-4'>
                                        <div className="projects-skills-cover">
                                            <h5>Skills</h5>
                                            <div className='projects-skills-pills-cover'>
                                                <div className='project-skills-pills'>
                                                    <p>LocalStorage</p>
                                                </div>
                                                <div className='project-skills-pills'>
                                                    <p>Forms</p>
                                                </div>
                                                <div className='project-skills-pills'>
                                                    <p>Context Api</p>
                                                </div>
                                                <div className='project-skills-pills'>
                                                    <p>React Hooks</p>
                                                </div>
                                                <div className='project-skills-pills'>
                                                    <p>useEffect Hooks</p>
                                                </div>
                                                <div className='project-skills-pills'>
                                                    <p>React Router Dom</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                    </div>
                </div>
            </div>
        </div>         
    </>
  )
}

export default Project3Details